import { createRouter, createWebHistory } from 'vue-router';

const HomePage = () => import('../pages/HomePage.vue');
const ProductPage = () => import('../pages/ProductPage.vue');
const AppServicesPage = () => import('../pages/AppServicesPage.vue');
const LearnPage = () => import('../pages/LearnPage.vue');
const EnterprisePage = () => import('../pages/EnterprisePage.vue');
//const ReviewPage = () => import('../pages/ReviewPage.vue');
const PaymentProcess = () => import('../pages/PaymentProcess.vue');
const ShippingPage = () => import('../pages/ShippingPage.vue');
//const CartLogin = () => import('../pages/CartLogin.vue');
const GetStarted = () => import('../pages/start.vue');
const ShopPage = () => import('../pages/ShopPage.vue');
const ProductPageBTC = () => import('../pages/ProductPageBTC.vue');
const PaymentOptions = () => import('../pages/PaymentOptions.vue');
const OrderSummary = () => import('../pages/OrderSummary.vue');
const BlogPage = () => import('../pages/BlogPage.vue');
const ArticlePage = () => import('../pages/ArticlePage.vue');
//const SpendlCardProducts = () => import('../pages/SpendlCardProducts.vue');
//const GenesisGiveaway = () => import('../pages/GoldenEntry.vue');
//const GenesisEntryConfirmed = () => import('../pages/GenesisEntryConfirmed.vue');


export const routes = [
  { path: '/', component: HomePage },
  { path: '/evmproducts', component: ProductPage },
  { path: '/wallet', component: AppServicesPage },
  { path: '/learn', component: LearnPage },
  { path: '/enterprise', component: EnterprisePage },
  //{ path: '/reviewpage', component: ReviewPage },
  { path: '/paymentprocess', component: PaymentProcess },
  { path: '/shippingpage', component: ShippingPage },
  //{ path: '/cartlogin', component: CartLogin },
  { path: '/start', component: GetStarted },
  { path: '/shop', component: ShopPage },
  { path: '/btcproducts', component: ProductPageBTC },
  { path: '/paymentoptions', component: PaymentOptions },
  { path: '/ordersummary/:id/:orderId', name: 'ordersummary', component: OrderSummary },
  { path: '/blog', component: BlogPage },
  { path: '/blog/:slug', name: 'ArticlePage', component: ArticlePage, props: true },
  //{ path: '/spendlcards', name: 'spendlcards', component: SpendlCardProducts },
  //{ path: '/evmgiveaway', component: GenesisGiveaway },
  //{ path: '/evmgiveawayentryconfirmed', component: GenesisEntryConfirmed },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; 
    } else {
      return { top: 0 }; 
    }
  }
});

// track page views
router.afterEach((to, from) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'G-41MSPKQTCK', {
      page_path: to.fullPath,
    }); 
  }
});

export default router;
